<template>
  <a-card :title="id?'编辑分组':'创建分组'" :bordered="false">
    <a-form :form="form">
      <a-form-item label="标签名称" v-bind="baseItemLayout">
        <a-input
          placeholder="请输入标签名称"
          v-decorator="['name', {rules: [{ required: true, message: '请输入角色名称', },{   validator: handleName}], validateTrigger: ['blur']}]"
        ></a-input>
      </a-form-item>
      <a-form-item label="分组类型" v-bind="baseItemLayout">
        <a-radio-group
          :disabled="disabled"
          @change="onGroupTypeChange"
          v-decorator="['catalog', {rules: [{ required: true, message: '请选择分组' }], validateTrigger: ['change', 'blur']}]"
        >
          <a-radio :value="2">手动分组</a-radio>
          <a-radio :value="1">自动分组</a-radio>
        </a-radio-group>
      </a-form-item>
      <template v-if="catalog==1">
        <a-form-item label="分组规则" v-bind="baseItemLayout" style="margin-bottom: 0">
          可根据不同规则配置自动分组，若该成员不在满足规则，则次日或次月会自动移除分组
        </a-form-item>
        <a-form-item label="  " :colon="false" :required="false" v-bind="baseItemLayout">
          <a-select
            :disabled="disabled"
            style="width: 400px"
            placeholder="请选择"
            @change="onOptionsChange"
            v-decorator="['type', {rules: [{ required: true, message: '请选择' }], validateTrigger: ['blur']}]"
          >
            <a-select-option v-for="item in optionsList" :key="item.value" :value="item.value">{{ item.key }}
            </a-select-option>
          </a-select>
          <template v-if="selectedOption">
            <span style="margin-left: 10px;margin-right: 10px">{{ selectedOption.word }}</span>
            <a-form-item style="display: inline-block;margin-bottom: 0">
              <a-input-number
                :disabled="disabled"
                :min="1"
                style="width: 100px"
                placeholder="请输入"
                v-decorator="['scale', {rules: [{ required: true, message: '请输入分组规则的计量数' }], validateTrigger: [ 'blur']}]"
              ></a-input-number>
              <span style="margin-left: 10px">{{ selectedOption.unit }}，即标记</span>
            </a-form-item>
          </template>

        </a-form-item>
      </template>
      <a-form-item label="  " :colon="false" :required="false" v-bind="baseItemLayout">
        <a-button type="primary" @click="saveEvent" :loading="saveLoading">保存</a-button>
        <a-button @click="backEvent" style="margin-left: 10px">返回</a-button>
      </a-form-item>
    </a-form>
  </a-card>
</template>

<script>
import formMixin from '../../../utils/mixins/formMixins'

export default {
  name: 'GroupEditor',
  mixins: [formMixin],
  data() {
    return {
      id: '',
      catalog: 1,
      disabled: false,
      optionsList: [],
      selectedOption: undefined
    }
  },

  created() {
    this.getOptions()
  },
  activated() {
    this.id = this.$route.query.id
    this.disabled = !!this.id
    if (this.id) {
      this.getGroupDetail()
    } else {
      this.selectedOption = undefined
      this.catalog = 1
      this.updateForm({
        name: undefined,
        catalog: 1,
        type: undefined,
        scale: undefined
      })
    }
  },
  methods: {
    onGroupTypeChange(e) {
      this.catalog = e.target.value
    },
    onOptionsChange(value) {
      this.getLogUtils().logWithTag('onOptionsChange', value)
      this.selectedOption = this.optionsList.find((item => item.value === value))
      this.updateForm({ scale: undefined })
    },
    saveEvent() {
      this.validateFormParams()
        .then(value => {
          this.saveRequest(value)
        }).catch(reason => this.getLogUtils().errorWithTag('validateFormParams', reason))
    },
    handleName(rule, value, callback) {
      this.handleText(rule, value, callback, 8)
    },
    getOptions() {
      this.getHttpServices().getUserService().post('merchant/v2/group/getStaffListRequestStatusItem')
        .then(list => {
          this.optionsList = list
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getGroupDetail() {
      this.getHttpServices().getUserService().post('merchant/v2/group/getGroup', { id: this.id })
        .then(detail => {
          if (detail) {
            this.onOptionsChange(detail.type)
            this.catalog = detail.catalog
            this.updateForm({
              name: detail.name,
              catalog: detail.catalog,
              type: detail.type,
              scale: detail.scale
            })
          }
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    saveRequest(value) {
      let requestPromise
      let tips
      const service = this.getHttpServices().getUserService()
      if (!this.id) {
        tips = '分组添加成功'
        requestPromise = service.post('merchant/v2/group/createGroup', value)
      } else {
        tips = '分组更新成功'
        const params = {
          id: this.id,
          name: value.name
        }
        requestPromise = service.post('merchant/v2/group/updateGroup', params)
      }
      this.saveLoading = true
      requestPromise.then(res => {
        this.$message.success(tips)
        setTimeout(() => this.backEvent(), 1000)
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.saveLoading = false)
    }
  }
}
</script>
<style lang="less">
@import "../../CustomPage";
</style>